import { Button, Column } from '@grubhubprod/gh-cookbook-react';
import { Row } from '@grubhubprod/gh-cookbook-react/dist';
import React, { useState } from 'react';
import { EmployeeListItem } from 'src/components/AddNewPeopleModal/AddNewPeopleModal.utils';
import { Employee } from 'src/components/EmployeeForm/EmployeeForm.utils';
import { SimpleDialog } from 'src/components/SimpleDialog/SimpleDialog';

export interface AddNewPeopleListProps {
  employee: Employee;
  onRemove: (email: string) => void;
  isFirst: boolean;
}

export function AddNewPeopleListItem({
  employee: { first_name, last_name, email },
  onRemove,
  isFirst,
}: AddNewPeopleListProps): JSX.Element {
  const [showRemoveConfirmation, setShowRemoveConfirmation] = useState(false);

  return (
    <EmployeeListItem isFirst={isFirst}>
      <Row gutter={8}>
        <Column gutter={8} phone={5} className="ellipsisOverflow">
          {first_name} {last_name}
        </Column>
        <Column gutter={8} phone={5} className="ellipsisOverflow">
          {email}
        </Column>
        <Column gutter={8} phone={2}>
          <Button
            variant="tertiary"
            className="tableActionButtons"
            onClick={() => setShowRemoveConfirmation(true)}
          >
            Remove
          </Button>
        </Column>
      </Row>
      {showRemoveConfirmation && (
        <SimpleDialog
          primaryActionFlavor="danger"
          title="Remove this person?"
          description="This person will no longer be on the list of new people you plan to add"
          primaryActionText="Remove"
          buttonsDirection="row-reverse"
          secondaryActionText="Cancel"
          onPrimaryActionClick={() => onRemove(email)}
          onSecondaryActionClick={() => setShowRemoveConfirmation(false)}
        />
      )}
    </EmployeeListItem>
  );
}
